<template>
  <footer v-if='$route.name == "Home"'>
    <div class='contain'>
      <div class='left'>
        <img class='logo' src='@/assets/img/logo.svg'>
        <p>Address1</p>
        <p>email@email.com</p>
        <p>123.456.7890</p>
      </div>

      <div class='right'>
        <nav>
          <router-link to=''>Get Started</router-link>
          <router-link to=''>About Us</router-link>
          <router-link to=''>Login</router-link>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: "Foot",
  components: {},
  data() {
    return {

    };
  },
  mounted() {},
  created() {

  },
  firestore() {
    return {};
  },
  methods: {
  },
  watch: {
    
  }
};
</script>

<style lang='scss'>
  footer  {
    .contain {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      padding: 50px 100px;
      &> div {
        @media screen and (max-width: 600px){
          width: 100%;
        }
      }
      .left {
        @media screen and (max-width: 600px){
          margin-bottom: 30px;
          padding-bottom: 30px;
          border-bottom: 2px solid #eaeaea;
        }
      }
      @media screen and (max-width: 1000px){
        padding: 50px;
      }
      @media screen and (max-width: 700px){
        padding: 50px 30px;
      }
    }
    .logo {
      height: 40px;
      margin-bottom: 20px;
    }
    .left p {
      margin-bottom: 0;
      margin-top: 5px;
    }
  }
</style>
